<template>
    <div v-loading="load" class="info-list">
        <Header/>
        <div class="blank20"/>
        <div class="rdg_biv_t">财务数据分析师全国统一报名入口</div>
        <div class="user_reg">
            <div class="r_tit">考试申请<span v-if="userInfo.exam_place !== ''">（已申请）</span></div>
            <div class="blank20"/>
            <div class="apply_content">
                <div class="img">
                    <img :src="userInfo.avatar">
                </div>
                <div>
                    <span>姓名：{{userInfo.username}}</span>
                    <span>身份证号：{{userInfo.id_number}}</span>
                    <span>电子邮箱：{{userInfo.email}}</span>
                    <span>考试日期：{{examDate}}</span>
                    <span>考点城市：
                        <select v-if="userInfo.exam_place === ''" v-model="selectExamPlace">
                            <option v-for="(item, index) in examPlace" :key="index" :value ="item">{{item}}</option>
                        </select>
                        <span style="display: inline-block;">{{userInfo.exam_place}}</span>
                    </span>
                </div>
                <div>
                    <span>性别：{{Number(userInfo.gender)===1?'男':'女'}}</span>
                    <span>联系电话：{{userInfo.mobile}}</span>
                    <span>项目类型：{{Number(userInfo.type)===0?'初级财务数据分析师':Number(userInfo.type)===1?'财务数据分析师（单证）':'财务数据分析师（双证）'}}</span>
                </div>
            </div>
            <div v-if="userInfo.exam_place === ''" class="step-btn" style="margin-left: 252px;margin-top:62px" @click="submit">确认申请</div>
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'userInfo',
        'examDate',
        'examPlace'
    ]),
    data() {
        return {
            selectExamPlace:'',
            load: false,
        }
    },
    components:{
    },
    created() {
    },
    methods: {
        async submit(){
            if(this.selectExamPlace === ''){
                this.$toast('请选择考点城市');
                return false;
            }
            const params = {
                exam_time:this.examDate,
                type:this.userInfo.type,
                exam_place:this.selectExamPlace,
            }
            try {
                this.load = true;
                const res = await this.$http.post('/api/user/applyExam',params);
                this.load = false;
                if(res){
                    await this.$store.dispatch('UPDATE_USERINFO');
                    this.$toast('提交成功');
                    const tem = setTimeout(() => {
                        location.href = '/applyExam';
                        clearTimeout(tem);
                    }, 1500);
                }
            } catch (error) {
                this.load = false;
                this.$toast(error.message||'请求失败');
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.apply_content{
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    color: #262525;
    div{
        min-width: 100px;
        margin-right: 34px;
        img{
            width: 126px;
            height: 155px;
        }
        span{
            display: block;
            margin-bottom: 10px;
        }
    }
}
</style>
